import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { SelectInput } from '../Form';

@observer
class IntervalInput extends React.Component {

  @observable timeUnit;

  componentWillMount() {
    const timeUnitOptions = this.props.inMinutes ? this.timeUnitOptionsMinutes : this.timeUnitOptions;
    const { value } = this.props;
    if (value >= timeUnitOptions[5].value) this.timeUnit = timeUnitOptions[5].value;
    else if (value >= timeUnitOptions[4].value) this.timeUnit = timeUnitOptions[4].value;
    else if (value >= timeUnitOptions[3].value) this.timeUnit = timeUnitOptions[3].value;
    else if (value >= timeUnitOptions[2].value) this.timeUnit = timeUnitOptions[2].value;
    else if (value >= timeUnitOptions[1].value) this.timeUnit = timeUnitOptions[1].value;
    else this.timeUnit = timeUnitOptions[0].value;
  }

  timeUnitOptions = [
    { label: 'Minutes', value: 1 * 60 * 1000 },
    { label: 'Hours', value: 60 * 60 * 1000 },
    { label: 'Days', value: 24 * 60 * 60 * 1000 },
    { label: 'Weeks', value: 7 * 24 * 60 * 60 * 1000 },
    { label: 'Months', value: 30 * 24 * 60 * 60 * 1000 },
    { label: 'Years', value: 1440 * 365 * 60 * 1000 },
  ];

  timeUnitOptionsMinutes = [
    { label: 'Minutes', value: 1 },
    { label: 'Hours', value: 60 },
    { label: 'Days', value: 24 * 60 },
    { label: 'Weeks', value: 7 * 24 * 60 },
    { label: 'Months', value: 30 * 24 * 60 },
    { label: 'Years', value: 1440 * 365 },
  ];

  render() {
    const { label, value, onChange, inMinutes } = this.props;

    return (
      <div className='formInput'>
        <div className='flex flex-row'>
          <label>{label}</label>
          <input type="text" value={!this.timeUnit || !+value ? '' : +value / this.timeUnit} onChange={e => onChange({ target: { value: +e.target.value * this.timeUnit } })} style={{ width: '88px', minWidth: '88px', margin: '10px 0', padding: '0 10px' }} />
          <SelectInput id={`${label}-time-unit-options`} label='' value={this.timeUnit} onChange={e => {
            onChange({ target: { value: (+value / this.timeUnit) * e.target.value } })
            this.timeUnit = +e.target.value;
          }} options={inMinutes ? this.timeUnitOptionsMinutes : this.timeUnitOptions} fields={{ label: 'label', value: 'value' }} small />
        </div>
      </div>
    )
  }
}

export default IntervalInput;


// WEBPACK FOOTER //
// ./src/components/Form/IntervalInput.js